import { useEffect, useState } from "react";
import { getAuth, subscribeAuth } from "./auth";

export function useAuth() {
  const [s, setS] = useState(getAuth());
  useEffect(() => subscribeAuth(setS), []);
  return s;
}
